import _defineProperty from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import * as tslib_1 from "tslib";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { forwardRefAs, Generic } from "../../base";
export var Divider = forwardRefAs(function (_a, ref) {
  var _classNames;

  var children = _a.children,
      className = _a.className,
      color = _a.color,
      vertical = _a.vertical,
      rest = tslib_1.__rest(_a, ["children", "className", "color", "vertical"]);

  return React.createElement(Generic, Object.assign({
    className: classNames("is-divider", (_classNames = {}, _defineProperty(_classNames, "is-".concat(color), color), _defineProperty(_classNames, "is-divider-vertical", vertical), _classNames), className),
    "data-content": children,
    ref: ref
  }, rest));
}, {
  as: "div",
  children: ""
});
Divider.displayName = "Divider";
Divider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  vertical: PropTypes.bool
};